import CryptoJS from 'crypto-js';


export const encryptWithAES = (data) => {
    const key = CryptoJS.enc.Utf8.parse("12345678909864425862123456789012"); // 32-byte key
    const iv = CryptoJS.enc.Utf8.parse("1234567890123456"); // 16-byte IV

    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(data), key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

